module.exports = __webpack_public_path__ + "img/b1.e0dd190.png";